// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"61afdd7e","455":"a7d0e74d","977":"27bf21b6"}[chunkId] + ".chunk.js";
};